import { useMutation } from "@apollo/client";
import { Button } from "@src/components/elements";
import { ArrowIcon } from "@src/components/elements/assets/ArrowIcon";
import { useAuth } from "@src/contexts/AuthProvider";
import { notifySuccess } from "@src/shared/notify";
import { gql } from "@src/__generated__";
import React from "react";
import styled from "styled-components/macro";
import { UserName } from "@src/components/modules/UserName";

const Style = styled.div`
  .page-border {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 700; /* must be the higher than all other elements */
    overflow: auto; /* moves scrollbars inside border */
    background: #fff;
    border: 5px solid #ff9900;
  }

  .exit-impersonation {
    position: absolute;
    z-index: 800;
    bottom: 0;
    right: 0;
    background-color: #ff9900;
    padding: 0.5rem;
  }
`;

const CREATE_REVERSE_IMPERATION_MUTATION = gql(`
  mutation ExitImpersonationMutation {
    createReverseImpersonationToken
  }
`);

export const ImpersonationBorder: React.FC = ({ children }) => {
  const { tokenUserData, updateCurrentUserState } = useAuth();
  const [createReverseImpersonationMutation] = useMutation(
    CREATE_REVERSE_IMPERATION_MUTATION,
  );

  async function fetchTokenAndReload() {
    await createReverseImpersonationMutation();
    await updateCurrentUserState();
    notifySuccess(`You are now viewing as yourself`);
  }

  return (
    <Style>
      {tokenUserData?.impersonatorId ? (
        <>
          <div className="page-border">{children}</div>
          <div className="exit-impersonation row">
            Viewing as <UserName user={tokenUserData} />
            <Button
              variant="tertiary"
              size="xsmall"
              onClick={fetchTokenAndReload}
            >
              <ArrowIcon />
              Back
            </Button>
          </div>
        </>
      ) : (
        <>{children}</>
      )}
    </Style>
  );
};
